import React, { useEffect, useState } from "react";
import styles from "./Render.module.scss";
import { Group, Image, Layer, Stage } from "react-konva";
import { fakeApi, filter } from "../../assets/fakeApi";
import { hex2rgba } from "../../helpers/hex2rgba";
import { Background, MaskImage, svgToURL } from "../../helpers/konvaProcessor";
import { useLocation, useParams } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Palette from "../Palette/Palette";
import { Html } from "react-konva-utils";
import useImage from "use-image";
import { gridColumnsCalculator } from "../../helpers/gridColumnsCalculator";
import useWindowSize from "../../hooks/useWindowSize";
import { SelectionComplete } from "../SelectionComplete/SelectionComplete";
import logo from "../../assets/logo.png";

const defaultSize = {
  width: 904,
  height: 389,
};
const aspectRatio = defaultSize.width / defaultSize.height;

function Render() {
  const [area, setArea] = useState([]);
  const [layer, setLayer] = useState();
  const [group, setGroup] = useState("all");
  const [picker, setPicker] = useState();
  const [scale, setScale] = useState(1);
  const [selected, setSelected] = useState([]);
  const [search, setSearch] = useState("");
  const [mosaicCombine, setMosaicCombine] = useState([]);
  const [mosaicSelected, setMosaicSelected] = useState([]);
  const [terminate, setTerminate] = useState(false);
  const [paletteType, setPaletteType] = useState("a");
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [reformSelected, setReformSelected] = useState([]);
  const [executionType, setExecutionType] = useState("paint");
  const [device, setDevice] = useState("desktop");
  const [renderResolution, setRenderResolution] = useState(defaultSize);

  const [svgPaint] = useImage(svgToURL());
  const params = useParams();
  const location = useLocation();
  const size = useWindowSize().width;

  const mosaic = executionType === "mosaic";
  const mixMosaicPath = location.state?.mosaic;

  useEffect(() => {
    if (size >= 1400) {
      setRenderResolution(defaultSize);
      setDevice("desktop");
    } else if (size >= 1200 && size < 1400) {
      setRenderResolution({ width: 800, height: 800 / aspectRatio });
      setDevice("laptop");
    } else if (size >= 992 && size < 1200) {
      setRenderResolution({ width: 650, height: 650 / aspectRatio });
      setDevice("tablet");
    } else if (size >= 768 && size < 992) {
      setRenderResolution({ width: 480, height: 480 / aspectRatio });
      setDevice("miniTablet");
    } else if (size < 768) {
      setRenderResolution({
        width: size - 35,
        height: (size - 35) / aspectRatio,
      });
      setDevice("mobile");
    }
  }, [size]);

  useEffect(() => {
    setScale(renderResolution.width / defaultSize.width);
  }, [renderResolution]);

  useEffect(() => {
    if (mixMosaicPath) {
      setExecutionType("mosaic");
    }
  }, [location]);

  const local = () => {
    if (location.state) {
      return location.state;
    } else {
      const parts = location.pathname.split("/");
      const type = parts[2];
      const name = parts[3];

      return {
        name: name,
        type: type,
      };
    }
  };

  const state = local();

  const exterior = state?.type === "exterior";

  const onAreaClick = (id) => {
    if (id === allMasks) {
      id.length === area?.length ? setArea([]) : setArea(id);
    } else {
      area?.includes(id)
        ? setArea([...area?.filter((i) => i !== id)])
        : setArea([...area, id]);
    }
  };

  const allMasks = layer?.map((i) => i.id);

  const onExteriorButtonsClick = (type) => {
    if (type === "paint") {
      setExecutionType("paint");
      setArea([]);
    } else if (type === "deco") {
      setExecutionType("deco");
      setArea([]);
    } else {
      setExecutionType("mosaic");
      onAreaClick(allMasks);
    }
  };

  function onChangPalette(type) {
    type === "a" || type === "b" ? setPaletteType(type) : setPaletteType();
  }

  const room =
    location.pathname === "/mixmosaic"
      ? fakeApi
          .find((i) => i?.type === "exterior")
          .data?.find((i) => i?.link === "cottage")
          .rooms?.find((i) => i.id === 1)
      : fakeApi
          .find((i) => i?.type === state?.type)
          .data?.find((i) => i?.link === state?.name)
          .rooms?.find((i) => i.id?.toString() === params?.id);

  useEffect(() => {
    setLayer(room?.masks);
  }, [params.id, state]);

  useEffect(() => {
    if (area?.length > 0 && picker) {
      layer?.find((i) => {
        if (area?.includes(i.id)) {
          const color = {
            color: `${picker}`,
          };
          Object.assign(i, color);
        }
      });
      setPicker();
    }
  }, [area, picker, layer]);

  return (
    <>
      <div className={styles.wrapper}>
        {!terminate && !mixMosaicPath && (
          <Navbar
            mosaic={mosaic}
            setGroup={setGroup}
            terminate={terminate}
            setSearch={setSearch}
            setTerminate={setTerminate}
          />
        )}
        <div className={styles.container}>
          <div className={styles.printable}>
            <img src={logo} alt="Siltek Logo" />
            <span>0 (800) 60 70 55</span>
          </div>
          <div
            className={styles.radioGroup}
            style={mosaic ? { height: "max-content" } : undefined}
          >
            {!terminate ? (
              <>
                {exterior && !mixMosaicPath && (
                  <div className={styles.exteriorButtons}>
                    <h2>Оберіть тип виконання</h2>
                    <form>
                      <button
                        type="button"
                        onClick={() => onExteriorButtonsClick("paint")}
                        style={
                          executionType === "paint"
                            ? {
                                backgroundColor: "var(--tangerine-yellow)",
                                fontWeight: 700,
                                cursor: "default",
                              }
                            : undefined
                        }
                      >
                        Фарбування
                      </button>
                      <button
                        type="button"
                        onClick={() => onExteriorButtonsClick("deco")}
                        style={
                          executionType === "deco"
                            ? {
                                backgroundColor: "var(--tangerine-yellow)",
                                fontWeight: 700,
                                cursor: "default",
                              }
                            : undefined
                        }
                      >
                        Штукатурка
                        <span>(декоративна)</span>
                      </button>
                      <button
                        type="button"
                        onClick={() => onExteriorButtonsClick("mosaic")}
                        style={
                          mosaic
                            ? {
                                backgroundColor: "var(--tangerine-yellow)",
                                fontWeight: 700,
                                cursor: "default",
                              }
                            : undefined
                        }
                      >
                        Штукатурка
                        <span>(мозаїчна)</span>
                      </button>
                    </form>
                  </div>
                )}
                {!mosaic && (
                  <>
                    <div className={styles.radioForm}>
                      <h2>Оберіть каталог кольорів</h2>
                      <form className={styles.palette}>
                        <button
                          type="button"
                          onClick={() => onChangPalette("a")}
                          style={
                            paletteType === "a"
                              ? {
                                  backgroundColor: "var(--tangerine-yellow)",
                                  fontWeight: 700,
                                  cursor: "default",
                                }
                              : undefined
                          }
                        >
                          Siltek
                        </button>
                        <button
                          type="button"
                          onClick={() => onChangPalette("b")}
                          style={
                            paletteType === "b"
                              ? {
                                  backgroundColor: "var(--tangerine-yellow)",
                                  fontWeight: 700,
                                  cursor: "default",
                                }
                              : undefined
                          }
                        >
                          Siltek Facade
                        </button>
                      </form>
                    </div>

                    <div className={styles.radioForm}>
                      <h2>Оберіть область фарбування</h2>
                      <form className={styles.grid}>
                        {layer?.map(({ id, tag: { name, subName } }) => (
                          <button
                            type="button"
                            value={id}
                            key={id}
                            className={
                              area?.includes(id)
                                ? styles.activeRadio
                                : undefined
                            }
                            onClick={() => onAreaClick(id)}
                          >
                            {name} {subName}
                          </button>
                        ))}

                        <button
                          type="button"
                          value="all"
                          onClick={() => onAreaClick(allMasks)}
                          style={{
                            gridColumn: `span ${gridColumnsCalculator(
                              layer?.length,
                              device,
                            )}`,
                          }}
                          className={
                            area?.length === allMasks?.length
                              ? styles.activeRadio
                              : undefined
                          }
                        >
                          Усі
                        </button>
                      </form>
                    </div>
                  </>
                )}
              </>
            ) : (
              <Navbar terminate={terminate} setTerminate={setTerminate} />
            )}
          </div>

          <div
            className={styles.viewer}
            style={mosaic ? { height: "max-content" } : undefined}
          >
            {!mosaic && (
              <Stage
                width={renderResolution?.width}
                height={renderResolution?.height}
              >
                <Layer>
                  <Background
                    src={room?.background}
                    renderResolution={renderResolution}
                  />
                </Layer>
                {layer?.map((i) => (
                  <Layer key={JSON.stringify(i.id + renderResolution)}>
                    <Group>
                      <MaskImage
                        item={i}
                        executionType={executionType}
                        mosaicCombine={mosaicCombine}
                        color={hex2rgba(i.color)}
                        // color={mosaicColorBlender(mosaicCombine)}
                        setArea={onAreaClick}
                        renderResolution={renderResolution}
                      />
                    </Group>
                    {terminate ? (
                      <Html
                        divProps={{
                          style: {
                            position: "absolute",
                            top: `${i.position?.y * scale}px`,
                            left: `${i.position?.x * scale}px`,
                            backgroundColor: "var(--white)",
                            padding: "10px 10px",
                            minWidth: "76px",
                            width: "max-content",
                            textAlign: "center",
                            borderRadius: "5px",
                            fontSize: "14px",
                            fontFamily: "var(--thin-font)",
                            transform: "translate(-50%, -50%)",
                            opacity: `${selectedAreas.includes(i.id) ? 1 : 0}`,
                          },
                        }}
                      >
                        <span>
                          {i.tag?.name}
                          {i.tag?.subName !== "" && ` ${i.tag?.subName}`}
                        </span>
                      </Html>
                    ) : (
                      <Group>
                        <Image
                          image={svgPaint}
                          x={i.position?.x * scale - 14}
                          y={i.position?.y * scale - 14}
                          opacity={area?.includes(i.id) ? 1 : 0}
                          onClick={() => onAreaClick(i.id)}
                        />
                      </Group>
                    )}
                  </Layer>
                ))}
              </Stage>
            )}

            {device !== "mobile" && (
              <SelectionComplete
                room={room}
                selected={selected}
                terminate={terminate}
                setTerminate={setTerminate}
                executionType={executionType}
                mosaicSelected={mosaicSelected}
                reformSelected={reformSelected}
              />
            )}

            {!terminate && (
              <>
                {executionType !== "mosaic" ? (
                  <ul className={styles.filter}>
                    <li
                      onClick={() => setGroup("all")}
                      className={
                        group === "all" ? styles.activeFilter : undefined
                      }
                    >
                      Усі
                    </li>
                    {filter.map(({ id, segment }) => (
                      <li
                        key={id}
                        onClick={() => setGroup(id)}
                        className={
                          group === id ? styles.activeFilter : undefined
                        }
                      >
                        {segment}
                      </li>
                    ))}
                  </ul>
                ) : (
                  // <span className={styles.filterMosaicSpan}>
                  //   Оберіть колір наповнювачів (потрібно обрати до 4-х кольорів)
                  // </span>
                  <></>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <Palette
        area={area}
        room={room}
        layer={layer}
        device={device}
        search={search}
        picker={picker}
        spectre={group}
        setArea={setArea}
        selected={selected}
        exterior={exterior}
        setSearch={setSearch}
        setPicker={setPicker}
        terminate={terminate}
        paletteType={paletteType}
        setSelected={setSelected}
        setTerminate={setTerminate}
        mosaicCombine={mosaicCombine}
        selectedAreas={selectedAreas}
        executionType={executionType}
        mosaicSelected={mosaicSelected}
        reformSelected={reformSelected}
        setMosaicCombine={setMosaicCombine}
        setSelectedAreas={setSelectedAreas}
        setMosaicSelected={setMosaicSelected}
        setReformSelected={setReformSelected}
      />
    </>
  );
}

export default Render;
